import fetcher from '../utils/api';

const dashboardService = {
  stats: async () => fetcher('dashboard/stats/', 'GET', true),
  recent: async () => fetcher('dashboard/recent?get_first=20', 'GET', true),
  recentSummary: async () => fetcher('dashboard/recent_summary', 'GET', true),
  created: async ({ sortParam, skip }) => {
    const queryStringArray = ['get_first=20'];

    if (skip) {
      queryStringArray.push(`skip=${skip}`);
    }
    if (sortParam) {
      queryStringArray.push(`sort_by=${sortParam}`);
    }
    const queryString = queryStringArray.length > 0 ? `?${queryStringArray.join('&')}` : '';

    return fetcher(`dashboard/created${queryString}`, 'GET', true);
  },
  shared: async ({ sortParam, skip }) => {
    const queryStringArray = ['get_first=20'];

    if (skip) {
      queryStringArray.push(`skip=${skip}`);
    }
    if (sortParam) {
      queryStringArray.push(`sort_by=${sortParam}`);
    }
    const queryString = queryStringArray.length > 0 ? `?${queryStringArray.join('&')}` : '';

    return fetcher(`dashboard/shared${queryString}`, 'GET', true);
  },
  mostPopularDocuments: async () => fetcher('dashboard/popular/', 'GET', true),
  recommendedExperts: async () => fetcher('users/top_creators/', 'GET', true)
};

export default dashboardService;
